import { render, staticRenderFns } from "./PurchaseBanner.vue?vue&type=template&id=e55716b8&scoped=true&"
import script from "./PurchaseBanner.vue?vue&type=script&lang=js&"
export * from "./PurchaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseBanner.vue?vue&type=style&index=0&id=e55716b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55716b8",
  null
  
)

export default component.exports